import { useQuery } from '@hooks/reactQuery';

import { getDashboardRequestStatusesSummaryByStatus } from '@api/dashboardPO';

import { extractQueryParams } from '@utils/common';

import { IDashboardRequestStatusSummaryByStatusDTO } from '@interfaces/platform/dto/platformDashboardDTO';

import { refetchOptions } from '@constants/common';
import { DASHBOARD_REQUEST_STATUSES_SUMMARY_BY_STATUS } from '@constants/queryKeys';

const useQueryDashboardRequestStatusesSummaryByStatus = (params: IDashboardRequestStatusSummaryByStatusDTO) => {
	const {
		data: dashboardRequestStatusesSummaryByStatus,
		isLoading: isLoadingDashboardRequestStatusesSummaryByStatus,
		isFetching: isFetchingDashboardRequestStatusesSummaryByStatus,
	} = useQuery({
		queryKey: [
			DASHBOARD_REQUEST_STATUSES_SUMMARY_BY_STATUS,
			params,
		],
		queryFn: extractQueryParams(getDashboardRequestStatusesSummaryByStatus),
		enabled: [!!params],
		...refetchOptions,
	});

	return {
		countOfRecords: dashboardRequestStatusesSummaryByStatus?.count || 0,
		dashboardRequestStatusesSummaryByStatus: dashboardRequestStatusesSummaryByStatus?.items || [],
		isLoadingDashboardRequestStatusesSummaryByStatus: isLoadingDashboardRequestStatusesSummaryByStatus
			|| isFetchingDashboardRequestStatusesSummaryByStatus,
	};
};

export default useQueryDashboardRequestStatusesSummaryByStatus;

